"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = (hex, alpha) => {
  try {
    let content = hex.replace('#', '');
    const hexadecimal = content.length > 3 ? content.match(/[a-f\d]{2}/gi) : content.split('');
    const color = hexadecimal.map(value => String(parseInt(value.length === 2 ? value : "".concat(value).concat(value), 16))).join(', ');
    return "rgba(".concat(color, ", ").concat(alpha || 0, ")");
  } catch (_unused) {
    return hex;
  }
};
exports.default = _default;